// extracted by mini-css-extract-plugin
export var fixedHeader = "FixedHeader-module--fixedHeader--50e6d";